import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cityFilled"
const CityFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 14.25C7.036 14.25 7.875 15.09 7.875 16.125S7.035 18 6 18 4.125 17.16 4.125 16.125 4.965 14.25 6 14.25M17.25 14.25C18.285 14.25 19.125 15.09 19.125 16.125S18.285 18 17.25 18 15.375 17.16 15.375 16.125 16.215 14.25 17.25 14.25" />
          <path
            fillRule="evenodd"
            d="M12.823 7.688C13.631 7.688 14.417 7.963 15.048 8.468L17.865 10.721 21.235 11.335C21.838 11.445 22.28 11.956 22.31 12.562H21C20.69 12.563 20.438 12.815 20.438 13.126S20.689 13.688 21 13.688H22.313V15.375C22.313 16.1 21.725 16.688 21 16.688H19.814Q19.874 16.415 19.875 16.125C19.875 14.675 18.7 13.5 17.25 13.5S14.625 14.675 14.625 16.125Q14.626 16.415 14.687 16.688H8.563Q8.624 16.415 8.625 16.125C8.625 14.675 7.45 13.5 6 13.5S3.375 14.675 3.375 16.125Q3.376 16.415 3.437 16.688H3C2.275 16.688 1.688 16.1 1.688 15.375V13.185C1.688 12.337 2.173 11.573 2.92 11.206L2.966 11.072 3.094 10.688H4.125C4.435 10.688 4.688 10.436 4.688 10.125S4.436 9.563 4.125 9.563H3.469L3.72 8.813H3.375C3.065 8.813 2.813 8.56 2.813 8.25S3.064 7.688 3.375 7.688zM9.445 9.836C9.637 10.348 10.127 10.687 10.675 10.687H16.02L14.345 9.348C13.913 9 13.375 8.812 12.822 8.812H9.063z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CityFilledIcon
